module.exports = __webpack_public_path__ + "img/1-1.65de9711.png";